import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";

import { SupportTicketResponse } from "../../aiTickets.types";
import { SUPPORT_TICKETS_QUERY_KEY } from "../../constants/enums";
import { requestGetTicket } from "./getTicket.request";

export const ticketDetailQueryKey = (ticketId: string | null) => [
  SUPPORT_TICKETS_QUERY_KEY,
  "detail",
  ticketId,
];

// One ticket by id, for `?ticketId=` links: the ticket may be resolved, or not
// on the list's current page, so it is loaded on its own.
const useGetTicket = (ticketId: string | null) => {
  return useQuery<SupportTicketResponse, ApiServiceError<ApiError>>({
    queryKey: ticketDetailQueryKey(ticketId),
    queryFn: async () => await requestGetTicket(ticketId as string),
    enabled: !!ticketId,
    onError: toastServerError,
  });
};

export default useGetTicket;
